"use client";

import useSizeController from '@/hooks/useSizeController';

import { useState } from "react";

import dynamic from 'next/dynamic';
const AiHotelSummary = dynamic(() => import('./AiHotelSummary'))

export default function HotelOverview({ description, hotelDetail, city, }: { city: string; description: string; hotelDetail: any; }) {
  const { innerWidth } = useSizeController()

  return (
    <>
      <div className='bg-secondary-50 mb-3  rounded-2xl flex gap-2 items-center justify-center min-h-20'>

        <AiHotelSummary hotelId={hotelDetail.id} />
      </div>
      <RenderTextWithImportantNote description={description} innerWidth={innerWidth} />
    </>
  );
};

const RenderTextWithImportantNote = ({ description, innerWidth }: { description: string, innerWidth: number }) => {
  const [showImportantNote, setShowImportantNote] = useState(false);

  // Check for "IMPORTANT NOTE:" and split the description
  const importantNoteIndex = description.indexOf('IMPORTANT NOTE:');
  const hasImportantNote = importantNoteIndex !== -1;

  // Extract text parts
  const beforeImportantNote = hasImportantNote
    ? description.slice(0, importantNoteIndex)
    : description;

  const importantNote = hasImportantNote
    ? description.slice(importantNoteIndex)
    : '';

  return (
    <div className="whitespace-pre-wrap">
      {/* Render the description text */}
      <p
        dangerouslySetInnerHTML={{
          __html: beforeImportantNote
            .replaceAll('&amp;quot;', '')
            .replaceAll('<br />\r\n<br />', '<br />')
            ?.slice(0, innerWidth > 1088 ? description.length : 250),
        }}
        className=""
      />

      {/* Render the Important Notes button and content */}
      {hasImportantNote && (
        <div className='-mt-4 md:block hidden'>
          <button
            onClick={() => setShowImportantNote((prev) => !prev)}
            className="text-sm text-indigo-500"
          >
            {showImportantNote ? 'Hide Important Notes' : 'Show Important Notes'}
          </button>
          {showImportantNote && (
            <p
              dangerouslySetInnerHTML={{
                __html: importantNote.replaceAll('&amp;quot;', '').replaceAll('<br />\r\n<br />', '<br />'),
              }}
              className="mt-4"
            />
          )}
        </div>
      )}
    </div>
  );
};
